import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from '#src/shared/error';

export type HomepagePageDataErrorCode = 'homepage_page_data_not_found';

export class HomepagePageDataError extends PageDataError<HomepagePageDataErrorCode> {}
setClassName(HomepagePageDataError, 'HomepagePageDataError');
